import React from "react";
// import { FaFacebookF, FaLinkedin, FaTwitter, FaYoutube, FaSkype } from 'react-icons/fa';

const TeamMembersCard = ({data}) => {
    return (
        <>
            <div className="">
                <div className="team-member item-style">
                    <div className="team-thumb">
                        {/* <img src={data.thumbnail} alt="employees" /> */}
                        {/* <div className="team-overlay">
                            <ul>
                                {data.fbLink ?
                                    <li>
                                        <a href={data.fbLink}>
                                            <FaFacebookF />
                                        </a>
                                    </li>
                                    : null
                                }
                                {data.twitterLink ?
                                    <li>
                                        <a href={data.twitterLink}>
                                            <FaTwitter/>
                                        </a>
                                    </li>
                                    : null
                                }
                                {data.linkedinLink ?
                                <li>
                                    <a href={data.linkedinLink}>
                                        <FaLinkedin />
                                    </a>
                                </li>
                                    : null
                                }
                                {data.skypeLink ?
                                <li>
                                    <a href={data.skypeLink}>
                                        <FaSkype />
                                    </a>
                                </li>
                                    : null
                                }
                                {data.youtubeLink ?
                                <li>
                                    <a href={data.youtubeLink}>
                                        <FaYoutube />
                                    </a>
                                </li>
                                : null
                                }
                            </ul>
                        </div> */}
                    </div>
                    {/* <h2>{data.title}</h2>
                    <h3>{data.sub_title}</h3> */}
                    <div className="employess" dangerouslySetInnerHTML={{ __html: data.description ? data.description : null}} />
                    {/* <h3>{data.description}</h3> */}
                </div>
            </div>
        </>
    );
}

export default TeamMembersCard;